import { request, getTokenManager } from '@/utils/http'

function resolveFileNameFromContentDisposition(contentDisposition: string | null): string | undefined {
  if (!contentDisposition) {
    return undefined
  }
  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]).trim()
    } catch {
      // ignore
    }
  }
  const normalMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
  if (normalMatch?.[1]) {
    return normalMatch[1].trim()
  }
  return undefined
}

/**
 * 上传空运运价 Excel
 */
export const uploadAirExcel = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return request.post<string>('/mq/air/excel/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 确认导入空运运价
 */
export const confirmAirImport = (batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/air/excel/confirm', null, {
    params: { batchNo, taskId }
  });

/**
 * 取消导入空运运价
 */
export const cancelAirImport = (batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/air/excel/cancel', null, {
    params: { batchNo, taskId }
  });

/**
 * 下载空运运价导入模板
 */
export const downloadAirExcelTemplate = () => {
  const fileId = import.meta.env.VITE_AIR_IMPORT_TEMPLATE_FILE_ID
  const token = getTokenManager().get()
  return fetch(`/gateway/universal/storage/findByFileId/${fileId}`, {
    method: 'GET',
    headers: token ? { Authorization: token } : undefined
  }).then(async res => {
    if (!res.ok) {
      throw new Error(`Download failed: ${res.status}`)
    }
    const blob = await res.blob()
    const fileName = resolveFileNameFromContentDisposition(res.headers.get('content-disposition')) || 'Air_Rate_Template.xlsx'
    return {
      blob,
      fileName
    }
  })
}
